<template>
  <div class="relative">
    <HintLabels
      v-if="state == undefined || state"
      :colors="colors"
      :labels="anomalyTypes"
      class="
        lg:absolute
        bg-white
        lg:bottom-0
        lg:left-4
        z-50
        lg:p-2
        rounded-md
        lg:shadow-md
      "
    />

    <div id="map" ref="mapElement"></div>
  </div>
</template>
<script>
import config from '@/configs/configs.js'
import { movingMarkerSrc } from '@/mixins/movingMarker'
import HintLabels from '../../elements/HintLabels.vue'

export default {
  props: [
    'path',
    'anomaly',
    'speeds',
    'date',
    'tripDetail',
    'realtime',
    'marker',
    'state',
  ],
  mixins: [movingMarkerSrc],
  data() {
    return {
      history: null,
      current_position: false,
      map: null,
      objs: [],
      maxSpeed: null,
      avgSpeed: null,
      uniqPath: null,
      uniqAnomaly: null,
      anomalyTypes: [
        this.$t('acceleration'),
        this.$t('braking'),
        this.$t('cornering'),
        this.$t('UNSUAL_SPEED'),
      ],
      colors: ['#0090fb', '#00e396', '#df44fa', '#ff4560'],
      marker_: null,
      movingMarker: null,
      polyline: null,
      anomalies: null,
    }
  },
  // mounted() {

  // },

  methods: {
    loadMap(moveMarker = true) {
      var map = L.map(this.$refs['mapElement'], { tap: false }).setView(
        [this.history[0][0], this.history[0][1]],
        12
      )
      L.tileLayer(config.tile, {
        attribution: '@ Carpo',
        id: 'mapbox/streets-v11',
        tileSize: 512,
        zoomOffset: -1,
        accessToken: config.leaflet,
      }).addTo(map)
      this.map = map

      this.polyline && this.map.removeLayer(this.polyline)
      this.anomalies && this.map.removeLayer(this.anomalies)

      if (moveMarker) {
        this.pathGenerator()
      }
    },
    pathGenerator() {
      this.uniqPath = this.uniqBy(this.history, JSON.stringify)
      let latlngs = []
      let len = this.history.length

      // let speeds = [];
      for (var i = 0; i < len; i++) {
        latlngs.push(new L.LatLng(this.history[i][0], this.history[i][1]))
        // speeds.push(this.tripDetail.speeds[i]);
      }
      // this.maxSpeed = Math.max(...speeds);
      // this.avgSpeed = speeds.reduce((a, b) => a + b, 0) / speeds.length;

      this.polyline = L.polyline(latlngs)
      this.polyline.setStyle({
        color: 'black',
      })
      this.map.fitBounds(L.latLngBounds(latlngs))
      this.map.addLayer(this.polyline)
      if (latlngs.length > 1) this.movingMarkerGenerator(latlngs)

      this.showSpeed(this.polyline)
    },
    movingMarkerGenerator(path) {
      if (this.realtime == undefined || !this.realtime) {
        this.setMovingMarker(path)
      } else {
        this.map.removeLayer(this.movingMarker)
        this.setMovingMarker(path)
      }
    },
    setMovingMarker(path) {
      var greenIcon = L.icon({
        iconUrl: '../../../../pin.png',
        iconSize: [38, 38],
      })
      this.movingMarker = L.Marker.movingMarker(path, 30000, {
        autostart: false,
        icon: greenIcon,
      }).addTo(this.map)
      this.map.addLayer(this.movingMarker)

      let movingMarker = this.movingMarker
      movingMarker.once('click', function () {
        movingMarker.start()
        movingMarker.closePopup()
        movingMarker.unbindPopup()
        movingMarker.on('click', function () {
          if (movingMarker.isRunning()) {
            movingMarker.pause()
          } else {
            movingMarker.start()
          }
        })
      })
    },
    showSpeed(path) {
      path.on('click', (ev) => {
        var latlng = this.map.mouseEventToLatLng(ev.originalEvent)
        for (var i = 0; i < this.uniqPath.length; i++) {
          if (
            this.distance(
              latlng.lat,
              latlng.lng,
              this.uniqPath[i][0],
              this.uniqPath[i][1],
              'K'
            ) <= 0.04
          ) {
            this.popupMaker(
              'SPEED',
              [this.uniqPath[i][0], this.uniqPath[i][1]],
              `<span class="flex ltr"> ${this.tripDetail.speeds[i]} Km/h</span>`,
              this.tripDetail.datetimes[i]
            )
            break
          }
        }
      })
    },
    generatePulsatingMarker(radius, type) {
      const cssStyle = `
        width: ${radius}px;
        height: ${radius}px;
        background: ${this.colors[type - 1]};
        color: ${this.colors[type - 1]};
        box-shadow: 0 0 0 ${this.colors[type - 1]};
      `
      return L.divIcon({
        html: `<span style="${cssStyle}" class="pulse"></span>`,
        className: '',
      })
    },
    onEachFeature(feature, layer) {
      if (feature) {
        layer.bindPopup(
          `${this.popupDetail(
            this.$t('ANOMALY_DETECT') + ':',
            this.anomalyTypes[feature.properties.anomaly - 1]
          )}`
        )
      }
    },
    distance(lat1, lon1, lat2, lon2, unit) {
      var radlat1 = (Math.PI * lat1) / 180
      var radlat2 = (Math.PI * lat2) / 180
      var theta = lon1 - lon2
      var radtheta = (Math.PI * theta) / 180
      var dist =
        Math.sin(radlat1) * Math.sin(radlat2) +
        Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta)
      if (dist > 1) {
        dist = 1
      }
      dist = Math.acos(dist)
      dist = (dist * 180) / Math.PI
      dist = dist * 60 * 1.1515
      if (unit == 'K') {
        dist = dist * 1.609344
      }
      if (unit == 'N') {
        dist = dist * 0.8684
      }
      return dist
    },
    loadAnomaly(objs, this_) {
      this.anomalies = L.geoJSON(objs, {
        pointToLayer: function (feature, latlng) {
          return L.marker([latlng.lng, latlng.lat], {
            icon: this_.generatePulsatingMarker(15, feature.properties.anomaly),
          })
        },
        onEachFeature: this_.onEachFeature,
      }).addTo(this.map)
    },
    popupDetail(title, content) {
      return content != null && content != ''
        ? `<div class="py-1 flex justify-between items-center"> <span class="text-gray-500">${title} </span> <span class="capitalize font-bold">${content}</span> </div>`
        : ''
    },
    uniqBy(a, key) {
      return [...new Map(a.map((x) => [key(x), x])).values()]
    },
    popupMaker(content, latlong, content2 = '', date) {
      L.popup({ maxWidth: 200 })
        .setLatLng(latlong)
        .setContent(
          `
        <div class="py-1 flex flex-col  gap-2">
          <div class="flex flex-row items-center justify-between items-center gap-2 w-full">
              <span class="text-gray-500">${this.$i18n.t(content)}: </span>
              <div class="flex items-center space-x-1 flex-row-reverse	"><span class="capitalize font-bold">${content2}</span> </div>
            </div>
            <div class="flex flex-row items-center justify-between items-center gap-2 w-full">
              <span class="text-gray-500">${this.$i18n.t('TIME')}: </span>
              <span class="capitalize font-bold">
                ${new Date(date).toLocaleDateString(
                  'fa-IR'
                )} <span class="text-gray-500 symbol mx-1">|</span>
                ${new Date(date).toLocaleTimeString('fa-IR')}
              </span>
            </div>
        </div>
        `
        )
        .addTo(this.map)
    },
  },
  watch: {
    tripDetail: {
      handler: function (val, oldVal) {
        if (val && val.points != null) {
          this.movingMarkerSrc().then((res) => {
            if (res) {
              this.history = val.points
              if (this.realtime == undefined || !this.realtime) {
                this.loadMap()
              } else {
                this.pathGenerator()
                this.map.setView(val.points[val.points.length - 1], 15)
              }

              let this_ = this
              if (val['anomalies'] != undefined) {
                this.objs = val['anomalies'].map((x, i) => ({
                  type: 'Feature',
                  properties: {
                    anomaly: x[1],
                  },
                  geometry: {
                    type: 'Point',
                    coordinates: val.points[i],
                  },
                }))
              }

              if (this.realtime) {
                this.$notify({
                  message: this.$i18n.t('SEE_SPEED'),
                  customClass: 'info_msg',
                  duration: 15000,
                  dangerouslyUseHTMLString: true,
                })
                setTimeout(function () {
                  this_.$notify({
                    message: this_.$i18n.t('SEE_ROUTE'),
                    customClass: 'info_msg',
                    duration: 0,
                    dangerouslyUseHTMLString: true,
                  })
                }, 2000)
              }
              // if (this.realtime == undefined || !this.realtime) {

              setTimeout(() => {
                this_.loadAnomaly(this_.objs, this_)
                this_.$notify({
                  message: this_.$i18n.t('ANOMALY_DETECTED', {
                    type: this_.objs.length,
                  }),
                  customClass: 'info_msg',
                  duration: 8000,
                  dangerouslyUseHTMLString: true,
                })
              }, 1000)
              // }
            }
          })
        } else {
          this.history = null
          this.map.removeLayer(this.polyline)
          this.map.removeLayer(this.anomalies)
        }
      },
      deep: true,
    },
    marker(val) {
      if (val) {
        this.history = [val.point]

        if (this.realtime == undefined || !this.realtime) {
          this.loadMap(false)
          // this.history = null
        } else {
          this.map.removeLayer(this.marker_)
        }
        var greenIcon = L.icon({
          iconUrl: '../../../../pin.png',
          iconSize: [38, 38],
        })

        this.marker_ = new L.Marker([val.point[0], val.point[1]], {
          draggable: false,
          icon: greenIcon,
        })
        this.map.addLayer(this.marker_)
        this.marker_.addTo(this.map)
      }
    },
  },
  components: {
    HintLabels,
    // Field,
  },
}
</script>
<style>
#map {
  z-index: 9;
}
</style>
